<template>
  <div :id="modalId" class="modal" v-show="opened" v-if="url" @click="$emit('closeModal')" style="cursor: zoom-out">
    <div class="modal-content img-detalhes">
      <img class="image-modal" :src="url" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    name: "ModalImage",
    props: ['opened', 'url'],
    data() {
      return {
        modalId: this.$helpers.ID()
      }
    }
  }
</script>

<style scoped>
  .modal {
    display: flex; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1050; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
  }

  /* Modal Content/Box */
  .modal-content {
    margin: auto;
    max-width: 700px;
  }

  .image-modal {
    width: 100%;
  }

  @media (max-width: 900px) {
    .modal-content {
      max-width: none;
      width: 100%;
    }
  }
</style>
